import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import { ICompanyPolicy, IVerificationSettings } from 'services/verificationSettings/types';

export const getVerificationSettings = (): IResponse<IVerificationSettings> =>
  axiosInstance.request({
    url: '/VerificationSettings',
    method: 'GET',
  });

export const getCompanyVerificationPolicies = (
  psaId: number,
  companyId: number,
): IResponse<ICompanyPolicy> =>
  axiosInstance.request({
    method: 'GET',
    url: `CompanyVerificationSettings/${psaId}/company/${companyId}`,
  });
